import { Routes, Route } from "react-router-dom";
import { PtlRouter } from "@/tra/tancis/ptli/router/PtlRouter";
import { ComnMdleRouter } from "@/tra/tancis/ptli/router/ComnMdleRouter";
import { CmntyRouter } from "@/tra/tancis/ptli/router/CmntyRouter";
import { UsrRouter } from "@/tra/tancis/ptli/router/UsrRouter";
import { AcrdtRouter } from "@/tra/tancis/ptli/router/AcrdtRouter";
import { MyPageRouter } from "@/tra/tancis/ptli/router/MyPageRouter";
import { BtchRouter } from "@/tra/tancis/ptli/router/BtchRouter";
import { ElctdocRouter } from "@/tra/tancis/ptli/router/ElctdocRouter";
import { CrtrRouter } from "@/tra/tancis/ptli/router/CrtrRouter";
import { SysmRouter } from "@/tra/tancis/ptli/router/SysmRouter";
import { PrcsMntrRouter } from "@/tra/tancis/ptli/router/PrcsMntrRouter";
import { StstclRouter } from "@/tra/tancis/ptli/router/StstclRouter";
import { SurvRouter } from "@/tra/tancis/ptli/router/SurvRouter";

import { EswiHsCodeRouter } from "@/tra/tancis/eswi/router/EswiHsCodeRouter";
import { EwcRouter } from "./EwcRouter";
import { RevwRouter } from "@/tra/tancis/ptli/router/RevwRouter";

/*
 * 응용기능별 Router
 * - 명명규칙 : 응용기능 2 레벨 메타 단어(용어) 카멜표기(첫글자 대문자) + Router
 * - 응용기능 2 레벨 별로 Router 분리 원칙(기본)
 * - 응용기능 레벨별로 소문자로 구분하여 경로 작성
 * - 최종 라우팅하는 주소는 화면 아이디에서 '-' 구분자를 빼고 소문자로 변환하여 작성
 * - element 에 해당 화면 컴포넌트 기입
 * - 화면에서 파라메터로 받아서 사용할 키값은 path 문자열에 ':변수명' 으로 기입하여 해당 컴포넌트 인지하여 사용
 */

export const PtliMainRouter = () => {
    return (
        <Routes>
            <Route path={`/acrdt/*`} element={<AcrdtRouter />} />
            <Route path={`/ptl/*`} element={<PtlRouter />} />
            <Route path={`/comnmdle/*`} element={<ComnMdleRouter />} />
            <Route path={`/cmnty/*`} element={<CmntyRouter />} />
            <Route path={`/usr/*`} element={<UsrRouter />} />
            <Route path={`/mypage/*`} element={<MyPageRouter />} />
            <Route path={`/btch/*`} element={<BtchRouter />} />
            <Route path={`/elctdoc/*`} element={<ElctdocRouter />} />
            <Route path={`/crtr/*`} element={<CrtrRouter />} />
            <Route path={`/sysm/*`} element={<SysmRouter />} />
            <Route path={`/prcsMntr/*`} element={<PrcsMntrRouter />} />
            <Route path={`/ststcl/*`} element={<StstclRouter />} />
            <Route path={`/revw/*`} element={<RevwRouter />} />
            <Route path={`/ewc/*`} element={<EwcRouter />} />
            <Route path={`/surv/*`} element={<SurvRouter />} />

            <Route path={`/esw/hs/*`} element={<EswiHsCodeRouter />} />
        </Routes>
    );
};
